module.exports = __webpack_public_path__ + "static/media/3.2605ac3a.svg";